import { render, staticRenderFns } from "./employee-card.vue?vue&type=template&id=2307b564&"
import script from "./employee-card.vue?vue&type=script&lang=js&"
export * from "./employee-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports